import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=37d1d380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d1d380"]])

export default __exports__